import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend/index"
import $ from "jquery"
import moment from "moment"
import Pusher from "pusher-js"
import React, { Component } from "react"
import {
    FormattedMessage,
    defineMessages,
    injectIntl
} from "react-intl"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import BottomPriceToggle from "../bottom-line/toggle.component"
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import UrlHelper from "../common/UrlHelper.js"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import SendEmailModal from "../common/email/sendemail.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx"
import ButtonWrapper from "../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import SendSmsModal from "../common/sms/SendSmsModal.tsx"
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import SendAsModal from "../invoice/components/SendAsModal"
import ReceivePaymentModal from "../invoice/receivepaymentmodal.component"
import QuestionConversationChatModal from "../question-conversation/questionconversationchatmodal.jsx"
import { INTEGRATION_KEY } from "../state/integration/Constants"
import { fetchPriceLevels } from "../state/price-level/PriceLevelActions"
import { setPricingTable } from "../state/pricing/actions"
import { QUOTE_STATUS } from "../state/quote/Constants"
import { TYPE_SMS_QUOTE } from "../state/template/TemplateType"
import QuoteAnalytics from "./analytics/analytics.component.jsx"
import QuoteForm from "./form.component.jsx"
import LiveQuote from "./livequote.component.jsx"
import ProjectEdit from "./project/edit.component.jsx"
import "./quoteedit.scss"

const queryString = require("query-string")

const messages = defineMessages({
    "title_template": {
        id: "quote.edit.project.title_template",
        defaultMessage: "{customerName} project",
    }
})

class QuoteEdit extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            quoteId: this.props.match.params.quoteId || "",
            quoteObject: null,
            projectObject: null,
            proposalObject: null,
            contractProposalObject: null,
            orderInfo: "",
            quoteStatus: "new",
            initialContactId: UrlHelper.getUrlParameterByName("c"),
            fromProjectId: this.props.match.params.fromProjectId || "",
            fromQuoteId: this.props.match.params.fromQuoteId || "",
            projectId: "",
            project: {},
            showQuoteForm: false,
            showEmptyQuoteBox: true,
            models: [],
            emails: [],
            visits: [],
            versions: [],
            proposalLink: "",
            identifier: "",
            deletedAt: "",
            proposalHash: "",
            emailSent: "",
            lastTimeSent: "",
            proposalToEmail: "",
            redirect: "",
            modal: "",
            customerName: "",
            createdAt: "",
            proposedAt: "",
            preApprovedAt: "",
            preDeclinedAt: "",
            approvedAt: "",
            declinedAt: "",
            liveQuoteStatus: "",
            liveQuoteVideoEnabled: false,
            notes: "",
            contact: null,
            nbQuoteItems: 0,
            displayPreviewInfoBanner: false,
            exportedToLightspeed: false,
            quoteExportFeatureEnabled: AppContext.hasFeatureIntegration(Features.ApprovedQuoteExport),
            quoteExportIntegration: null,
            showCustomerSectionInfoBanner: false,
            showProjectSectionInfoBanner: false,
            loading: false,
            editMode: true,
            loadingProject: false,
            initialQuoteLoading: true,
            previewLoading: false,
            isPusherBound: false,
            pusherChannel: null,
            fromEmail: this.props.fromEmail,
            internalNotes: [],
            paymentFromDraft : false,
        }
        if (this.state.quoteExportFeatureEnabled) {
            this.state.quoteExportIntegration = AppContext.integrations.filter(i => i.attributes.features.filter(f => f === Features.ApprovedQuoteExport).length > 0)[0]
        }
        this.openEmptyQuoteEdit = this.openEmptyQuoteEdit.bind(this)
        this.saveProject = this.saveProject.bind(this)
        this.generateProposal = this.generateProposal.bind(this)
        this.cancelDraft = this.cancelDraft.bind(this)
        this.resetToDraft = this.resetToDraft.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.deleteQuote = this.deleteQuote.bind(this)
        this.unarchiveQuote = this.unarchiveQuote.bind(this)
        this.IsProjectEditable = this.IsProjectEditable.bind(this)
        this.onQuoteSectionClick = this.onQuoteSectionClick.bind(this)
        this.onDisabledClickProjectSection = this.onDisabledClickProjectSection.bind(this)
        this.onDisabledClickQuoteSection = this.onDisabledClickQuoteSection.bind(this)
        this.onRefreshItemList = this.onRefreshItemList.bind(this)
        this.handleQuoteRefresh = this.handleQuoteRefresh.bind(this)
        this.handleEditQuote = this.handleEditQuote.bind(this)
        this.closeEditMode = this.closeEditMode.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.markAsSent = this.markAsSent.bind(this)
        this.openSendEmail = this.openSendEmail.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.openLiveQuoteSetup = this.openLiveQuoteSetup.bind(this)
        this.handleCloseModalAndRefresh = this.handleCloseModalAndRefresh.bind(this)
        this.copyLink = this.copyLink.bind(this)
        this.clearCopyLink = this.clearCopyLink.bind(this)
        this.closeLiveMode = this.closeLiveMode.bind(this)
        this.openConversationModal = this.openConversationModal.bind(this)
        this.refreshQuote = this.refreshQuote.bind(this)
        this.openVideoCall = this.openVideoCall.bind(this)
        this.openSendSms = this.openSendSms.bind(this)
        this.refreshQuoteLinkAndOpenSms = this.refreshQuoteLinkAndOpenSms.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handlePaymentOnDraft = this.handlePaymentOnDraft.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        SideBar.activateMenu("quote")
        const quoteId = nextProps.match.params.quoteId
        if (quoteId) {
            this.loadQuote(quoteId, (nextProps.location && nextProps.location.state && nextProps.location.state.contactId) ? nextProps.location.state.contactId : "")
        } else {
            if (nextProps.location && nextProps.location.state && nextProps.location.state.contactId) {
                this.updateCustomer(nextProps.location.state.contactId)
            }
        }
    }

    componentDidMount() {
        SideBar.activateMenu("quote")
        const quoteId = this.props.match.params.quoteId
        if (quoteId && !this.state.quoteObject) {
            this.loadQuote(quoteId, (this.props.location && this.props.location.state && this.props.location.state.contactId) ? this.props.location.state.contactId : "")
        } else {
            if (this.props.location && this.props.location.state && this.props.location.state.contactId) {
                this.createWithContact(this.props.location.state.contactId)
            }
        }
        const uri = queryString.parse(this.props.location.search)
        if (uri.em) {
            this.setState({
                editMode: uri.em === "1",
            })
        }
    }

    handleEditQuote(quoteId) {
        this.setState({
            loading: true,
            editMode: true,
        }, () => {
            this.loadQuote(quoteId)
        })
        window.scrollTo(0, 0)
    }

    closeEditMode(e) {
        e.preventDefault()
        this.loadQuote(this.state.quoteId)
        this.setState({
            editMode: false,
        })
        window.scrollTo(0, 0)
    }
    refreshQuote() {
        this.loadQuote(this.state.quoteId, null, true)
        EventBus.dispatch(EventBus.TopicRefreshQuoteFormSilently, {
            quoteId: this.state.quoteId,
        })
    }

    loadPusher(proposal) {
        if (proposal.attributes.isLiveProposalRunning && !this.state.pusherChannel) {
            const pusher = new Pusher(proposal.attributes.variables.global.pusherKey, {
                cluster: proposal.attributes.variables.global.pusherCluster
            })
            const channel = pusher.subscribe("live-quotes-" + this.state.quoteId)
            channel.bind("live-proposal-refresh", this.refreshQuote)
            channel.bind("live-conversation-refresh", this.refreshQuote)
            this.setState({
                pusherChannel: channel
            })
        } else if (!proposal.attributes.isLiveProposalRunning && this.state.pusherChannel) {
            this.state.pusherChannel.unbind("live-proposal-refresh")
            this.state.pusherChannel.unbind("live-conversation-refresh")
        }
    }

    createWithContact(contactId) {
        const project = this.state.project
        project.contactId = contactId
        this.setState({
            project: project,
        }, () => {
            this.saveProject(this.state.project)
        })
    }

    loadQuote(quoteId, contactId = "", noLoading = false) {
        let quote = {}

        if (!this.state.project.contactId && this.state.quoteStatus && !noLoading) {
            this.setState({
                loading: true,
            })
        }
        AppContext.getApiClient().get("/quotes/" + quoteId).then(q => {
            if (q.error) {
                return {id: "", attributes: {}}
            }
            quote = q
            if (!noLoading) {
                this.setState({
                    loadingProject: this.state.editMode,
                })
            }
            return AppContext.getApiClient().get("/projects/" + q.attributes.projectId)
        }).then(p => {
            let showQuoteForm = true

            let imageIdMap = []
            if (p.attributes.images) {
                imageIdMap = p.attributes.images.map(im => im.id)
            }

            let documentIdMap = []
            if (p.attributes.documents) {
                documentIdMap = p.attributes.documents.map(doc => doc.id)
            }

            let projectContactId = contactId ? contactId : p.attributes.contactId

            this.setState({
                loading: false,
                quoteExportFeatureEnabled: AppContext.hasFeatureIntegration(Features.ApprovedQuoteExport),
                quoteStatus: quote.attributes.status,
                quoteId: quoteId,
                identifier: quote.attributes.identifier,
                deletedAt: quote.attributes.deletedAt,
                projectId: p.id,
                showQuoteForm: showQuoteForm,
                showEmptyQuoteBox: !showQuoteForm,
                notes: quote.attributes.notes,
                exportedToLightspeed: quote.attributes.externalLinks.filter(l => l.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL).length > 0,
                customerName: p.attributes.contact ? p.attributes.contact.attributes.name : "",
                contact: p.attributes.contact,
                createdAt: quote.attributes.createdAt,
                proposedAt: quote.attributes.proposedAt,
                preApprovedAt: quote.attributes.preApprovedAt,
                preDeclinedAt: quote.attributes.preDeclinedAt,
                approvedAt: quote.attributes.approvedAt,
                declinedAt: quote.attributes.declinedAt,
                quoteObject: quote,
                liveQuoteStatus: quote.attributes.liveQuoteStatus,
                liveQuoteVideoEnabled: quote.attributes.liveQuoteVideoEnabled,
                proposalHash: quote.attributes.proposalHash,
                projectObject: p,
                internalNotes: p.attributes.internalNotes,
                conversationThreads: (p && p.attributes.conversationThreads.length > 0)
                    ? p.attributes.conversationThreads : [
                        {
                            messages: []
                        }
                    ],
                selectedThread: 0,
                project: {
                    projectId: p.id,
                    title: p.attributes.title,
                    description: p.attributes.description,
                    assignToUserId: p.attributes.assignToUserId,
                    shipToContactId: p.attributes.shipToContactId,
                    contactId: projectContactId,
                    potentialAmount: p.attributes.potentialAmount,
                    probability: p.attributes.probability,
                    customFieldValues: p.attributes.customFieldValues,
                    imageIds: imageIdMap,
                    images: p.attributes.images,
                    documentIds: documentIdMap,
                    documents: p.attributes.documents,
                    location: p.attributes.location,
                    locationId: p.attributes.locationId,
                    poNumber: p.attributes.poNumber,
                },
                loadingProject: false,
                editMode: this.state.initialQuoteLoading ? ["new", "draft", "cancelled"].includes(quote.attributes.status) : this.state.editMode,
            }, () => {
                this.setGlobalStateInitialValues(quote)
                this.setState({
                    initialQuoteLoading: false,
                })
                if (contactId) {
                    this.updateCustomer(contactId)
                }
            })
        })
        AppContext.getApiClient().get("/quotes/" + quoteId + "/proposals").then(res => {
            if (res.data.length > 0) {
                const proposal = res.data.filter(prop => prop.attributes.documentType === "quote")[0]
                const contractProposal = res.data.find(prop => prop.attributes.documentType === "contract")

                const visits = proposal.attributes.visits.filter(v => v.attributes.userId === "")
                this.setState({
                    proposalObject: proposal,
                    contractProposalObject: contractProposal,
                    proposalLink: proposal.attributes.publicLink,
                    proposalHash: proposal.attributes.hash,
                    proposalLastEmailSubject: proposal.attributes.lastEmailSubject,
                    proposalLastEmailContent: proposal.attributes.lastEmailContent,
                    proposalToEmail: proposal.attributes.variables.customer.email,
                    visits: visits,
                    emailSent: proposal.attributes.emailSent,
                    lastTimeSent: proposal.attributes.lastTimeSent,
                })
                this.loadPusher(proposal)
                AppContext.getApiClient().get("/proposals/" + proposal.id + "/emails").then(res => {
                    const emails = res.data || []
                    this.setState({
                        emails: emails.map(e => {
                            e.attributes.proposalType = "quote"
                            return e
                        }),
                    }, () => {
                        if (this.state.contractProposalObject) {
                            AppContext.getApiClient().get("/proposals/" + this.state.contractProposalObject.id + "/emails").then(res => {
                                let emails = res.data || []
                                emails = this.state.emails.concat(emails.map(e => {
                                    e.attributes.proposalType = "contract"
                                    return e
                                }))
                                emails.sort((a, b) => {
                                    return (moment(b.attributes.createdAt).valueOf() > moment(a.attributes.createdAt).valueOf()) ? 1 : -1
                                })
                                this.setState({
                                    emails,
                                })
                            })
                        }
                    })
                })
                AppContext.getApiClient().get("/projects/" + proposal.attributes.projectId + "/quotes").then(res => {
                    const quotes = res.data || []
                    this.setState({
                        versions: quotes,
                    })
                })
            } else {
                this.setState({
                    proposalObject: null,
                    proposalLink: "",
                    proposalHash: "",
                    proposalLastEmailSubject: "",
                    proposalLastEmailContent: "",
                    emailSent: 0,
                    lastTimeSent: "",
                    emails: [],
                    visits: [],
                })
            }
        })
    }

    setGlobalStateInitialValues(quote) {
        this.props.dispatch(fetchPriceLevels())
        this.props.dispatch(setPricingTable(quote))
    }

    setDefaultTitle(project) {
        if (!project.title) {
            return AppContext.getApiClient().get("/contacts/" + project.contactId).then(c => {
                project.title = this.props.intl.formatMessage(messages["title_template"], {
                    customerName: c.attributes.name
                })
                return Promise.resolve(project)
            })
        } else {
            return Promise.resolve(project)
        }
    }

    updateCustomer(contactId){
        AppContext.getApiClient().patch(`/quotes/${this.state.quoteId}`, {
            contactId: contactId
        }).then(() => {
            this.handleQuoteRefresh(this.state.quoteId)
        })
    }

    saveProject(project) {
        this.setState({
            project: project,
            loadingProject: this.state.editMode,
        }, () => {
            if (this.state.projectId) {

                if (project.contactId) {
                    return this.updateCustomer(project.contactId)
                }

                return AppContext.getApiClient().patch("/projects/" + this.state.projectId, {
                    title: project.title,
                    description: project.description,
                    assignToUserId: project.assignToUserId,
                    shipToContactId: project.shipToContactId,
                    locationId: project.locationId,
                    contactId: project.contactId,
                    potentialAmount: project.potentialAmount,
                    customFieldValues: project.customFieldValues || {},
                    imageIds: project.imageIds || [],
                    documentIds: project.documentIds || [],
                    probability: project.probability ? project.probability.toString() : "0",
                    poNumber: project.poNumber,
                    documentType: "quotes",
                }).then(p => {
                    this.setState({
                        projectObject: p,
                        loadingProject: false,
                        initialContactId: "",
                    }, () => {
                        this.loadQuote(this.state.quoteId)
                    })
                })
            } else if (this.state.fromProjectId && this.state.fromQuoteId) {
                this.setDefaultTitle(project).then(project => {
                    return AppContext.getApiClient().post("/quotes/" + this.state.fromQuoteId + "/duplicate", {
                        title: project.title,
                        quoteId: this.state.fromQuoteId,
                        contactId: project.contactId,
                    })
                }).then(q => {
                    EventBus.dispatch(EventBus.TopicQuoteCreated, {
                        quote: q,
                    })
                    EventBus.dispatch(EventBus.TopicUrlPathChange, {
                        path: "/quotes/" + q.id + "/edit",
                    })
                    this.loadQuote(q.id)
                })
            } else {
                if (!project.contactId) {
                    this.setState({
                        initialContactId: ""
                    })
                    return
                }
                return this.setDefaultTitle(project).then(project => {
                    return AppContext.getApiClient().post("/projects", {
                        title: project.title,
                        description: project.description,
                        assignToUserId: project.assignToUserId,
                        shipToContactId: project.shipToContactId,
                        contactId: project.contactId,
                        potentialAmount: project.potentialAmount || "0",
                        imageIds: project.imageIds || [],
                        documentIds: project.documentIds || [],
                        customFieldValues: project.customFieldValues || {},
                        probability: "0.10",
                        documentType: "quotes",
                    })
                }).then(p => {
                    if (p.error) {
                        return {id: ""}
                    }
                    this.setState({projectId: p.id, initialContactId: ""})
                    return AppContext.getApiClient().post("/quotes", {
                        projectId: p.id,
                    })
                }).then(q => {
                    EventBus.dispatch(EventBus.TopicQuoteCreated, {
                        quote: q,
                    })
                    EventBus.dispatch(EventBus.TopicUrlPathChange, {
                        path: "/quotes/" + q.id + "/edit",
                    })
                    this.loadQuote(q.id)
                })
            }
        })
    }

    openEmptyQuoteEdit(e) {
        if (this.isQuoteEnabled()) {
            AppContext.getApiClient().post("/quotes/" + this.state.quoteId + "/draft", {}).then(r => {
                this.loadQuote(this.state.quoteId)
                this.refreshTitle()
            })
        }
        e.preventDefault()
    }

    openQuoteEditWithGuide(modelId) {
        return function (e) {
            if (this.isQuoteEnabled()) {
                AppContext.getApiClient().patch("/quotes/" + this.state.quoteId, {
                    modelId: modelId
                }).then(r => {
                    this.loadQuote(this.state.quoteId)
                    this.refreshTitle()
                })
            }
            e.preventDefault()
        }.bind(this)
    }

    generateProposal(event) {
        event.preventDefault()
        if (this.state.nbQuoteItems == 0) {
            this.setState({showPreviewInfoBanner: true})
        } else {
            this.createProposal().then(res => {
                const uri = this.state.editMode ? "?em=1" : ""
                this.setState({
                    redirect: <Redirect to={"/proposals/" + res.attributes.hash + "/preview" + uri}/>
                })
            })
        }
    }

    createProposal() {
        if (this.state.proposalObject) {
            return Promise.resolve(this.state.proposalObject)
        }
        return AppContext.getApiClient().get(`/quotes/${this.state.quoteId}/proposals`).then((res) => {
            const quoteProposals = res.data
            if (quoteProposals.length > 0) {
                return Promise.resolve(quoteProposals[0])
            } else {
                return AppContext.getApiClient().post("/proposals", {
                    quoteId: this.state.quoteId,
                    contactId: this.state.project.contactId,
                    hash: this.state.quoteObject.attributes.proposalHash,
                })
            }
        })
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        window.scrollTo(0, 0)
        this.setState({loading: true})
        this.createProposal().then(res => {
            AppContext.getApiClient().post("/proposals/" + res.attributes.hash + "/send-by-email", {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                pdfIncluded: pdfIncluded,
                fromEmail: fromEmail,
                bccEmail: bccEmail,
                fromName: fromName,
            }).then(res => {
                if (res.id) {
                    this.setState({
                        editMode: false,
                    })
                    this.handleQuoteRefresh(this.state.quoteId, this.state.liveQuoteStatus === "running")
                } else {
                    this.setState({loading: false})
                }
            })
        })
    }

    markAsSent(e) {
        e.preventDefault()
        this.sendProposal("", "", "", "", "", "", "", "", "", "")
    }

    getCustomerEmailAddresses() {
        return GlobalHelper.formatContactEmail(this.state.contact.attributes.email, this.state.contact.attributes.name)
    }

    refreshQuoteLinkAndOpenSms(event) {
        AppContext.getApiClient().get("/quotes/" + this.state.quoteId + "/proposals").then(res => {
            if (res.data.length > 0) {
                const proposal = res.data.filter(prop => prop.attributes.documentType === "quote")[0]
                const proposalLink = proposal.attributes.publicLink
                this.openSendSms(event, proposalLink)
            }
        })
    }

    openSendSms(event, proposalLink) {
        event.preventDefault()
        const project = this.state.projectObject
        const accountId = project.attributes.accountId
        const customerPhoneNumbers = project.attributes.contact.attributes.phoneNumbers
        const countryCode = project.attributes.location.attributes.organization.attributes.address.countryCode
        this.setState({
            modal: <SendSmsModal
                phoneNumber={GlobalHelper.getCustomerNumber(customerPhoneNumbers)}
                projectId={project.id}
                contactId={this.state.contact ? this.state.contact.id : ""}
                accountId={accountId}
                templateType={TYPE_SMS_QUOTE}
                countryCode={countryCode}
                onSubmit={() => this.sendProposal("", "", "", "", "", "", "", "", "", "")}
                onClose={this.handleCloseModal}
            />,
        })
    }

    openSendEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                locationId={this.state.project.locationId}
                toEmail={this.getCustomerEmailAddresses()}
                proposalType={"quote"}
                templateKey={"send-proposal"}
            />
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            previewLoading: true,
        })
        this.createProposal().then(res => {
            this.setState({
                previewLoading: false,
                modal: <ProposalPreviewModal
                    onClose={this.handleCloseModal}
                    pdfLink={res.attributes.variables.document.pdfUri}
                    hash={res.attributes.hash}
                    publicLink={res.attributes.publicLink}
                    proposalType={"quote"}
                />
            })
        })
    }

    openLiveQuoteSetup(event) {
        event.preventDefault()
        this.setState({
            modal: <LiveQuote
                onSubmit={() => {
                    this.handleQuoteRefresh(this.state.quoteId)
                }}
                onClose={this.handleCloseModalAndRefresh}
                quoteId={this.state.quoteId}
            />
        })
    }

    openVideoCall() {
        AppContext.getEventBus().dispatch(EventBus.TopicOpenVideoCall, {
            companyName: AppContext.getAccount().attributes.companyName,
            userName: AppContext.getUserLoggedIn().attributes.name,
            roomName: this.state.quoteId,
        })
        setTimeout(() => {
            if ($("#jitsi iframe").length > 0) {
                $("#jitsiOpenButton").addClass("d-none")
            }
        }, 500)
    }

    cancelDraft(event) {
        event.preventDefault()
        return AppContext.getApiClient().post("/quotes/" + this.state.quoteId + "/cancel", {}).then(_ => {
            this.loadQuote(this.state.quoteId)
            this.refreshTitle()
        })
    }

    resetToDraft(event) {
        event.preventDefault()
        return AppContext.getApiClient().patch("/quotes/" + this.state.quoteId, {
            status: "draft",
        }).then(_ => {
            this.loadQuote(this.state.quoteId)
            this.refreshTitle()
        })
    }

    closeLiveMode(event) {
        event.preventDefault()
        return AppContext.getApiClient().patch("/quotes/" + this.state.quoteId, {
            liveQuoteStatus: "disabled",
        }).then(_ => {
            this.loadQuote(this.state.quoteId, null, true)
            this.refreshTitle()
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ""
        })
        if(this.state.paymentFromDraft) {
            this.setState({
                paymentFromDraft: false
            })
            this.sendProposal("", "", "", "", "", "", "", "", "", "")
        }
    }

    handleCloseModalAndRefresh() {
        this.loadQuote(this.state.quoteId, null, true)
        this.refreshTitle()
        this.setState({
            modal: ""
        })
    }

    deleteQuote(event) {
        event.preventDefault()
        return AppContext.getApiClient().delete("/quotes/" + this.state.quoteId, {}).then(q => {
            this.loadQuote(q.id)
        })
    }

    unarchiveQuote(event) {
        event.preventDefault()
        return AppContext.getApiClient().put("/quotes/" + this.state.quoteId + "/unarchive", {}).then(q => {
            this.setState({isEditable: true})
            this.loadQuote(q.id)
        })
    }

    IsProjectEditable() {
        return true
        //return this.state.quoteStatus == "new" || this.state.quoteId == ''
    }


    refreshTitle(quoteId) {
        if (!quoteId) {
            quoteId = this.state.quoteId
        }
        EventBus.dispatch(EventBus.TopicRefreshCurrentBreadcrumb, {
            path: "/quotes/" + quoteId + "/edit",
        })
    }

    onRefreshItemList(items, quote, quoteStatus) {
        this.setState({
            quoteObject: quote,
        })
        if (this.state.nbQuoteItems != items.length) {
            this.setState({nbQuoteItems: items.length, quoteStatus: quoteStatus})
        }
    }

    containsNegativeTotal() {
        let isNegative = false
        for (let total of this.state.quoteObject.attributes.totals) {
            if (parseFloat(total.attributes.totalAmount) < 0) {
                isNegative = true
                break
            }
        }
        return isNegative
    }

    renderQuoteForm() {
        let className = "ui-module px-3 py-0"
        if (this.state.exportedToLightspeed) {
            className += " border border-danger"
        }
        return <QuoteForm
            projectId={this.state.projectId}
            quoteId={this.state.quoteId}
            forceAllowEdit={this.state.editMode}
            onRefreshItemList={this.onRefreshItemList}
            className={className}
        />
    }

    renderEmptyQuote() {
        let startFromGuide = ""
        let guides = ""
        if (this.state.models.length > 0) {
            startFromGuide = <span>
                &nbsp;
                <FormattedMessage
                    id="quote.edit.box.or_start_from_model_btn"
                    defaultMessage="or start from a guide:"
                />
            </span>

            guides = <ul className="list-unstyled">
                {this.state.models.map(m => <li key={m.id}>
                    <a href="#" onClick={this.openQuoteEditWithGuide(m.id)}
                       className="btn btn-outline-primary btn-sm mt-2">
                        {m.attributes.name}
                    </a>
                </li>)}
            </ul>
        }

        return <div className="row">
            <div className="col-12 ui-module">
                <div className="text-align-center">
                    <a href="#" onClick={this.openEmptyQuoteEdit} className="btn btn-outline-primary btn-sm">
                        <FormattedMessage
                            id="quote.edit.box.start_btn"
                            defaultMessage="Start adding products"
                        />
                    </a>
                    {startFromGuide}
                    {guides}
                </div>
            </div>
        </div>
    }

    clearCopyLink() {
        this.setState({
            buttonCopyLabel: ""
        })
    }

    copyLink(e) {
        e.preventDefault()
        let copyText = document.getElementById("proposalPublicLink")
        copyText.select()
        copyText.setSelectionRange(0, 99999) /*For mobile devices*/
        document.execCommand("copy")
        this.setState({
            buttonCopyLabel: <FormattedMessage
                id="price_list.analytics.link_copied_btn"
                defaultMessage="Link Copied!"
            />
        })
        setTimeout(this.clearCopyLink, 2000)
    }

    openConversationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <QuestionConversationChatModal
                project={this.state.projectObject}
                publicLink={this.state.proposal.attributes.publicLink}
                selectedThread={this.state.selectedThread}
                onClose={this.handleCloseModal}
                quoteId={this.state.quoteId}/>
        })
    }

    renderQuoteStatus() {
        if (this.state.showEmptyQuoteBox) {
            return ""
        }
        let isPreviewButtonDisabled = true
        if (this.state.nbQuoteItems > 0) {
            isPreviewButtonDisabled = false
        }

        const conversation = (this.state.conversationThreads && this.state.conversationThreads.length > 0) ?
            this.state.conversationThreads[this.state.selectedThread] : {messages: []}

        if (this.state.deletedAt) {
            return <div className="row">
                <div className={"col-12 d-flex justify-content-between"}>
                    <div>
                        <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchiveQuote}>
                            <FormattedMessage
                                id="quote.edit.status.unarchive_btn"
                                defaultMessage="Unarchive"
                            />
                        </ActionButton>
                    </div>
                    <div>
                        <p className="text-align-right text-warning m-0">
                            <FormattedMessage
                                id="quote.edit.status.archived_quote_info"
                                defaultMessage="This quote is archived and can't be found in search results."
                            />
                        </p>
                    </div>
                </div>
            </div>
        }

        const isOnBoarding = AppContext.getAccount().attributes.onBoardingStatus === "pending"

        switch (this.state.quoteStatus) {
        case QUOTE_STATUS.NEW:
        case QUOTE_STATUS.DRAFT:
            return <div>
                <div className="row justify-content-end">
                    {this.containsNegativeTotal() &&
                        <div>
                            <p className="text-align-right text-warning mb-3 mr-3">
                                <FormattedMessage
                                    id="quote.negative_total_amount_warning"
                                    defaultMessage="The total amount of this quote is negative."
                                />
                            </p>
                        </div>
                    }
                </div>
                <div className="row">
                    <div className={"col-12 d-flex justify-content-between"}>
                        <div>
                            {
                                !isOnBoarding && this.state.liveQuoteStatus !== "running" ? <ConfirmButton
                                    onModalRender={(m, c) => {
                                        this.setState({modal: m}, c)
                                    }}
                                    onClick={this.deleteQuote}
                                    identifier={this.state.identifier}
                                    className="btn btn-outline-danger mr-2">
                                    <Icon value={"trash"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.edit.status.delete_btn"
                                        defaultMessage="Delete"
                                    />
                                </ConfirmButton> : ""
                            }
                            {
                                this.state.nbQuoteItems > 0 ? <ActionButton className={"btn btn-outline-primary"}
                                                                            isLoading={this.state.previewLoading}
                                                                            onClick={this.openPreview}>
                                    <Icon value={"eye"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="invoice.edit.preview_btn"
                                        defaultMessage="Preview"
                                    />
                                </ActionButton> : ""
                            }
                            {/* TODO: To be enable soon...  */}
                            {/*{this.state.liveQuoteStatus === 'disabled' && <button className={"btn btn-outline-primary ml-2"}*/}
                            {/*    onClick={this.openLiveQuoteSetup}>*/}
                            {/*    <Icon value={"desktop"} className={"mr-1"} />*/}
                            {/*    <FormattedMessage*/}
                            {/*        id="quote.edit.live_quote_btn"*/}
                            {/*        defaultMessage="Live Quote"*/}
                            {/*    />*/}
                            {/*</button>}*/}
                            {
                                conversation.messages.length > 0 && <button
                                    className={"btn btn-outline-primary ml-2"} onClick={this.openConversationModal}>
                                    <Icon value={"comments"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.analytics.question.conversation"
                                        defaultMessage="Conversation"
                                    />
                                    {conversation.messages.length > 0 && <span
                                        className={"ml-1 px-1 badge badge-warning badge-pill"}>{conversation.messages.length}</span>}
                                </button>
                            }
                            {
                                this.state.liveQuoteStatus === "running" && this.state.liveQuoteVideoEnabled && $("#jitsi iframe").length == 0 &&
                                <button
                                    className={"btn btn-primary ml-2"} id={"jitsiOpenButton"}
                                    onClick={this.openVideoCall}>
                                    <Icon value={"video"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.analytics.question.video_call"
                                        defaultMessage="Start video call"
                                    />
                                </button>
                            }
                            {
                                this.state.liveQuoteStatus === "running" &&
                                <ActionButton className={"btn btn-secondary ml-2"}
                                              onClick={this.closeLiveMode}>
                                    <Icon value={"power-off"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.edit.close_live_quote_btn"
                                        defaultMessage="Close live mode"
                                    />
                                </ActionButton>
                            }
                        </div>
                        <div className={"d-flex"}>
                            {this.state.liveQuoteStatus === "running" && <div className={"d-flex"}>
                                <div className={"mr-2 "}>
                                    <input
                                        style={{width: "200px"}}
                                        id={"proposalPublicLink"}
                                        className="form-control"
                                        type="text"
                                        value={this.state.proposalLink}
                                    />
                                </div>
                                <div className={"mr-2"}>
                                    <button
                                        className={"btn " + (this.state.buttonCopyLabel ? "btn-success" : "btn-primary")}
                                        onClick={this.copyLink}>
                                        <Icon value={"copy"} className={"mr-1"}/>
                                        {this.state.buttonCopyLabel ? this.state.buttonCopyLabel : <FormattedMessage
                                            id="price_list.analytics.copy_link_btn"
                                            defaultMessage="Copy Link"
                                        />}
                                    </button>
                                </div>
                            </div>}
                            {!isOnBoarding && this.state.liveQuoteStatus !== "running" ?
                                <ActionButton className="btn btn-outline-warning mr-2" onClick={this.cancelDraft}>
                                    <Icon value={"ban"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.edit.status.cancel_draft_btn"
                                        defaultMessage="Cancel Draft"
                                    />
                                </ActionButton> : ""}
                            {this.state.liveQuoteStatus !== "running" &&
                                <ActionButton className="btn btn-outline-primary mr-2"
                                              disabled={isPreviewButtonDisabled} onClick={this.generateProposal}>
                                    <Icon value={"pencil-ruler"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.edit.status.edit_design_btn"
                                        defaultMessage="Edit design"
                                    />
                                </ActionButton>}
                            {
                                this.state.liveQuoteStatus !== "running" && <ActionButton
                                    className="btn btn-outline-success mr-2"
                                    onClick={this.markAsSent}
                                    disabled={this.containsNegativeTotal()}>
                                    <Icon value={"bullseye"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="quote.edit.preview.mark_as_done_btn"
                                        defaultMessage="Mark as done"
                                    />
                                </ActionButton>
                            }
                             {
                                this.state.quoteStatus == "draft" &&
                                this.state.quoteObject.attributes.depositBalance > 0 && <ActionButton
                                    className="btn btn-outline-success mr-2"
                                    onClick={this.receivePayment}>
                                    <Icon value={"dollar-sign"} className={"mr-1"}/>
                                    <FormattedMessage
                                        id="invoice.analytics.receive_payment_btn"
                                        defaultMessage="Receive payment"
                                    />
                                </ActionButton>
                            }
                            <ButtonWrapper
                                protectedClassName={"btn btn-success mr-2"}
                                premium={false}
                                protectionRule={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms)}
                                redirectToAccount={true}
                                className="btn btn-success mr-2"
                                onClick={(event) => {
                                    this.refreshQuoteLinkAndOpenSms(event)
                                }}
                                disabled={this.containsNegativeTotal()}>
                                <Icon value={"mobile-alt"} className={"mr-1"}/>
                                <FormattedMessage
                                    id="invoice.edit.issue_and_send_sms_btn"
                                    defaultMessage="SMS"
                                />
                            </ButtonWrapper>

                            <button
                                className="btn btn-success mr-2"
                                onClick={this.openSendEmail}
                                disabled={this.containsNegativeTotal()}>
                                <Icon value={"envelope"} className={"mr-1"}/>
                                {
                                    this.state.liveQuoteStatus === "running" ? <FormattedMessage
                                        id="quote.edit.preview.send_live_quote_btn"
                                        defaultMessage="Send live quote"
                                    /> : <FormattedMessage
                                        id="checkout.email_placeholder"
                                        defaultMessage="Email"
                                    />
                                }

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        case QUOTE_STATUS.CANCELLED:
            return <div className="row">
                <div className={"col-12 d-flex justify-content-start"}>
                    <div>
                        <ConfirmButton
                            onModalRender={(m, c) => {
                                this.setState({modal: m}, c)
                            }}
                            onClick={this.deleteQuote}
                            identifier={this.state.identifier}
                            className="btn btn-outline-danger mr-2">
                            <Icon value={"trash"} className={"mr-1"}/>
                            <FormattedMessage
                                id="quote.edit.status.delete_btn"
                                defaultMessage="Delete"
                            />
                        </ConfirmButton>
                        {!isOnBoarding ?
                            <ActionButton className="btn btn-outline-warning mr-2" onClick={this.resetToDraft}>
                                <Icon value={"trash-restore"} className={"mr-1"}/>
                                <FormattedMessage
                                    id="quote.edit.status.undo_cancel_draft_btn"
                                    defaultMessage="Undo cancel"
                                />
                            </ActionButton> : ""}
                    </div>
                </div>
            </div>
        default:
            return <div className="row">
                <div className={"col-12 d-flex justify-content-end"}>
                    <div>
                        {this.state.editMode &&
                            <button className="btn btn-outline-secondary mb-2 mr-2" onClick={this.closeEditMode}>
                                <Icon value={"times"} className={"mr-1"}/>
                                <FormattedMessage
                                    id="quote.edit.close_edit_btn"
                                    defaultMessage="Close edit mode"
                                />
                            </button>}
                        <ActionButton className="btn btn-primary mb-2 mr-2" disabled={isPreviewButtonDisabled}
                                      onClick={this.generateProposal}>
                            <Icon value={"pencil-ruler"} className={"mr-1"}/>
                            <FormattedMessage
                                id="quote.edit.status.edit_design_btn"
                                defaultMessage="Edit design"
                            />
                        </ActionButton>
                    </div>
                </div>
            </div>
        }
    }

    isQuoteEnabled() {
        return this.state.projectId && this.state.project.contactId && this.state.project.title
    }

    onDisabledClickProjectSection() {
        this.setState({showCustomerSectionInfoBanner: true}, () => {
            document.getElementById("quote.edit.project.customer_section_begin").focus()
        })
    }

    onDisabledClickQuoteSection() {
        if (!this.state.project.title && !this.state.project.contactId) {
            this.setState({showCustomerSectionInfoBanner: true}, () => {
                document.getElementById("quote.edit.project.customer_section_begin").focus()
            })
        } else if (!this.state.project.title && this.state.project.contactId) {
            this.setState({showProjectSectionInfoBanner: true})
        }
    }

    onQuoteSectionClick() {
        if (!this.state.project.title || !this.state.project.contactId) {
            this.onDisabledClickQuoteSection()
        }
    }

    handleQuoteRefresh(quoteId, noLoading) {
        const id = quoteId ?? this.state.quoteId
        this.loadQuote(id, null, noLoading)

        EventBus.dispatch(EventBus.TopicUrlPathChange, {
            path: "/quotes/" + id + "/edit",
        })

    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handlePaymentOnDraft}
                depositPayableObject={this.state.quoteObject}
                project={this.state.projectObject}
            />
        })
    }

    handlePaymentOnDraft(paymentType, appliedCreditMemoId) {
        if(paymentType != '') {
        this.setState({
            paymentFromDraft : true,
            modal: <SendAsModal
            onClose={this.handleCloseModal}
            sendBySMS={this.openSendSms}
            sendByEmail={this.openSendEmail}
            printPdf={this.printPdf}
            />,
        })
    }
        else {
            this.handleCloseModal()
        }
    }

    printPdf() {
        this.createProposal().then(res => {
            this.handleCloseModal()
            const printUrl = res.attributes.printUrl
            GlobalHelper.redirectToPrintPdf(printUrl)
        })
    }

    render() {
        if (this.state.loading || this.state.loadingProject) {
            return <div>
                <LoadingSpinner/>
            </div>
        }

        if (!["new", "draft", "cancelled"].includes(this.state.quoteStatus) && !this.state.editMode) {
            return <QuoteAnalytics
                quote={this.state.quoteObject}
                project={this.state.projectObject}
                proposal={this.state.proposalObject}
                contractProposal={this.state.contractProposalObject}
                versions={this.state.versions}
                onRefresh={this.handleQuoteRefresh}
                emails={this.state.emails}
                onEdit={this.handleEditQuote}
                internalNotes={this.state.internalNotes}
            />
        }

        let extraClass = "d-none"
        if (this.isQuoteEnabled()) {
            extraClass = ""
        }

        let quotePanel = ""
        if (this.state.showQuoteForm) {
            quotePanel = <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        {this.renderQuoteStatus()}
                    </div>
                </div>
            </div>
        }


        return <div>
            {this.state.redirect}
            {this.state.modal}
            <ProjectEdit
                className="row"
                value={this.state.projectObject}
                isEditable={this.IsProjectEditable()}
                initialContactId={this.state.initialContactId}
                quoteId={this.state.quoteId}
                quote={this.state.quoteObject}
                onChange={this.saveProject}
                onDisabledClick={this.onDisabledClickProjectSection}
                showCustomerSectionInfoBanner={this.state.showCustomerSectionInfoBanner}
                showProjectSectionInfoBanner={this.state.showProjectSectionInfoBanner}
                refreshObject={this.handleQuoteRefresh}
            />

            {!this.state.loadingProject &&
                [<div className={"row m-0 py-1 px-3 mb-5 " + extraClass} onClick={this.onQuoteSectionClick}>
                    <div className="col-md-12 mb-3">
                        <div className="row d-flex justify-content-between">
                            <h4 className="p-0 custom-lead">
                                <FormattedMessage
                                    id="quote.edit.box.items_box_title"
                                    defaultMessage="Items"
                                />
                            </h4>
                            {this.state.exportedToLightspeed ? <h5 className="p-0">
                                <small className={"text-danger"}>
                                    <Icon value={"exclamation-triangle"} className={"mr-2"}/>
                                    <FormattedMessage
                                        id="quote.edit.box.items_warning_lightspeed"
                                        defaultMessage="This quote has already been exported to Lightspeed. Modification on the pricing table won't be exported to Lightspeed."
                                    />
                                </small>
                            </h5> : ""}
                            <BottomPriceToggle/>
                        </div>
                        {this.state.showEmptyQuoteBox ? this.renderEmptyQuote() : this.state.showQuoteForm && this.renderQuoteForm() }
                    </div>
                </div>,
                    quotePanel]
            }

        </div>
    }

}

const mapState = (state, props) => ({...props})
const mapDispatch = (dispatch) => {
    return {
        dispatch,
    }
}
export default connect(mapState, mapDispatch)(injectIntl(QuoteEdit))




// WEBPACK FOOTER //
// ./src/quote/edit.component.jsx